class GlobalVars {
  getApiEndPoint() {
    //return "https://localhost:7255";
    return "https://api.breednet.com.au";
  }
}

export default new GlobalVars();
